module.exports = __webpack_public_path__ + "static/media/218.38d68203.webp";